import { localDatabaseUrls } from "../backend/constants";
import { getJWTToken } from "../shared/fetchWrapper/fetchWrapper";
import { postAPI } from "../backend/commons";

export const uploadCJWDIFile = async (file, isApproved, threshold, effectiveDate) => {
    const fileFormData = new FormData();
    fileFormData.append('file', file);

    const tokenInfo = await getJWTToken();
    if (!tokenInfo) {
        window.location.href = "/";
    }
//empty commit
    let apiUrl =
        localDatabaseUrls.baseURL +
        localDatabaseUrls.serviceURL.cjwDiUploadFile +
        '?is-approved=' + isApproved +
        '&threshold=' + threshold +
        '&supplier-flag=DI';

    // Add effective-date if provided
    if (effectiveDate) {
        apiUrl += '&effective-date=' + effectiveDate;
    }

    return await postAPI(apiUrl, fileFormData, tokenInfo);
}
